import type { LangStrings } from './en';

export const ko: LangStrings = {
  back: '뒤로',
  next: '다음',
  retry: '재시도',
  replay: '리플레이',
  sector: '섹터',
  sectors: '섹터',
  levels: '레벨',
  cleared: '클리어',
  open: '오픈',
  locked: '잠김',
  tba: 'TBA',
  slot_reserved: '예약 슬롯',
  sfx_on: '효과음 켬',
  sfx_off: '효과음 끔',
  reset_progress: '진행 초기화',
  wiped_reloading: '초기화됨, 재로딩…',
  got_it: '› 확인 ‹',

  boot_eyebrow: '캐스케이드 프로토콜  //  BUILD',
  boot_tagline: '한 탭. 한 캐스케이드. 재도전 없음.',
  boot_subtitle: '信号崩壊  ·  CASCADE LOGIC',
  boot_cta: '› 탭하여 시작 ‹',
  boot_region: '리전 ▣ /7',
  boot_top_left: 'HAYTERWAVE//SYSCORE',
  boot_top_right_status: '0xC7A5 // 온라인',

  menu_header_subtitle: 'NØDUS / 섹터.선택',
  menu_engine_label: '신호 붕괴 엔진',
  menu_signals_down: '신호 격파',
  menu_tap_chapter: '챕터를 탭하여 진입',
  menu_language_label: '언어',

  chapter_signals_down: '신호 격파',
  chapter_tba_label: '0xTBA',
  chapter_coda_name: '코다',
  chapter_coda_tagline: '새로운 것은 없다. 전부 조합한다.',

  hud_tap_to_breach: '▾  노드를 탭하여 침투  ▾',
  hud_tap_to_skip: "건너뛰기  ▸▸",
  hud_drag_zoom_help: '드래그로 이동 · 휠/핀치로 줌',
  hud_required: '필수',
  hud_core_online: '코어 가동',
  hud_core_down: '코어 격파',

  tut_tap_any_node: '아무 노드나 탭',
  tut_they_all_work: '여기선 다 통한다',

  brief_eyebrow: '◂ 브리핑 ▸',
  brief_title: '한 탭.\n한 캐스케이드.',
  brief_line_1: '› 탭은 단 한 번뿐.',
  brief_line_2: '› 네트워크에서 연쇄 반응이 일어난다.',
  brief_line_3: '› 모든 필수 노드(시안 다이아)를 무너뜨려 승리.',
  brief_line_4: '› 펄스가 보호 노드(빨강)에 닿지 않게 하라.',
  brief_begin: '› 브리핑 시작 ‹',

  result_win_headline: '시스템 붕괴',
  result_fail_headline: '캐스케이드 실패',
  result_first_clear: '› 첫 클리어 ‹',
  result_try_label: '› 시도',
  result_cleared_suffix: '클리어',
  result_aborted_suffix: '실행 중단',
  result_win_body_template: '{ticks}틱. {nodes}개 노드 격파.',

  fail_protected_overload: '보호 노드 과부하. 캐스케이드가 닿으면 안 될 곳을 쳤다.',
  fail_forbidden_trigger: '금지선이 신호를 운반했다. 강력한 경보 발동.',
  fail_required_not_reached: '필수 노드에 펄스가 도달하지 않았다. 연쇄가 닿지 못함.',
  fail_required_under_threshold: '필수 노드에 펄스가 부족했다. 첫 펄스가 감쇠한 뒤 두 번째가 도착.',
  fail_core_not_collapsed: '코어 생존. 캐스케이드가 도달하기 전에 소멸.',
  fail_core_under_threshold: '코어에 펄스가 왔지만 부족, 적시에 수렴하지 못함.',
  fail_core_shielded: '코어 펄스 차단. 실드가 아직 가동 중.',
  fail_chain_died: '아무것도 도달하지 못한 채 연쇄가 끊어졌다.',
  fix_protected_overload: '캐스케이드가 빨간 위험에 닿지 않는 스타터를 골라라. 각 스타터의 하류부터 추적하라.',
  fix_forbidden_trigger: '빨간 점선 와이어로 발사하는 스타터는 피해라. 닿는 순간 경보가 울린다.',
  fix_required_not_reached: '스타터가 그 노드와 연결되어 있지 않다. 화살표를 봐라, 방향성 와이어는 한 방향뿐.',
  fix_required_under_threshold: '두 펄스를 그 노드로 보내는 경로를 찾아라, 스플리터나 두 수렴 경로면 된다.',
  fix_core_not_collapsed: '코어로의 수렴을 더 늘려라. 스플리터, 캐패시터, 릴레이가 이를 위해 있다.',
  fix_core_under_threshold: '펄스가 너무 늦게 온다. 스플리터로 쌓거나 같은 틱에 도착시켜라.',
  fix_core_shielded: '결정타가 들어가기 전에 모든 실드를 떨궈라. 늦게 도착하는 지연 와이어가 깔끔하다.',
  fix_chain_died: '스타터가 한 노드에만 연결되어 있다. 그물 중심의 노드를 골라라.',

  popup_new_node: '◂ 새 노드 타입 ▸',
  popup_new_wire: '◂ 새 와이어 타입 ▸',

  node_normal_title: '노드',
  node_normal_tagline: '기본 단위. 탭하여 캐스케이드 시작.',
  node_normal_b1: '첫 펄스에 무너진다.',
  node_normal_b2: '모든 열린 출력 와이어로 펄스 발사.',
  node_normal_b3: '임계값 없음, 한 방에 사라진다.',

  node_required_title: '필수 노드',
  node_required_tagline: '모든 필수 노드를 무너뜨려 승리.',
  node_required_b1: '시안 다이아. 대기 시 약하게 맥동해 눈에 띈다.',
  node_required_b2: '일부는 같은 윈도우에 2회 이상 펄스 필요.',
  node_required_b3: '하나라도 놓치면 실행 실패.',
  node_required_note: '노드 주변의 작은 점 링이 충전 진행도를 보여준다.',

  node_protected_title: '보호 노드',
  node_protected_tagline: '닿으면 실행 전체가 죽는다.',
  node_protected_b1: '빨간 위험 십자. 모서리 브래킷 표시.',
  node_protected_b2: '펄스 닿으면 즉시 실패.',
  node_protected_b3: '절대 도달하지 않는 경로를 설계하라.',

  node_relay_title: '릴레이',
  node_relay_tagline: '무너지면 잠긴 와이어를 연다.',
  node_relay_b1: '금색 셰브런. 타겟은 점선의 잠긴 와이어.',
  node_relay_b2: '릴레이가 떨어지면 잠긴 와이어가 연결된다.',
  node_relay_b3: '보호된 노드로의 경로를 여는 데 유용.',

  node_shield_title: '실드',
  node_shield_tagline: '경호원. 다른 노드 대신 맞아준다.',
  node_shield_b1: '보호 대상을 둘러싼 녹색 육각 링.',
  node_shield_b2: '실드된 노드에 직접 펄스 = 무효.',
  node_shield_b3: '먼저 실드를 떨군 다음 결정타를 날려라.',
  node_shield_note: '지연 와이어(점선 금)는 실드 후 일격에 최적.',

  node_splitter_title: '스플리터',
  node_splitter_tagline: '모든 출력에 펄스 증폭.',
  node_splitter_b1: '마젠타 갈래. 1펄스 입력 → 출력당 N펄스.',
  node_splitter_b2: 'X 마커가 분할 계수를 표시.',
  node_splitter_b3: '높은 임계값 코어에 필요한 다중 타격 제공.',

  node_capacitor_title: '캐패시터',
  node_capacitor_tagline: '펄스를 저장했다가 재방출, 버퍼.',
  node_capacitor_b1: '노란 캐패시터 기호. 펄스를 3틱 뒤에 전달.',
  node_capacitor_b2: '경로에 내장된 지연으로 취급하라.',
  node_capacitor_b3: '실드 강하 후에 후속 펄스를 착탄시킬 수 있다.',

  node_core_title: '코어',
  node_core_tagline: '목표. 높은 임계값, 빠른 감쇠.',
  node_core_b1: '보라색 반응로. 많은 수렴 펄스로 무너진다.',
  node_core_b2: '충전이 감쇠한다, 펄스가 촘촘히 도착해야 한다.',
  node_core_b3: '대개 실드가 지킨다. 떨군 뒤 코어를 침수시켜라.',
  node_core_note: '코어가 있는 레벨은 코어 붕괴로 승리. 필수 노드(있다면)도 카운트.',

  wire_directional_title: '방향성 와이어',
  wire_directional_tagline: '단방향 도체. 화살표가 있는 시안.',
  wire_directional_b1: '펄스는 화살표 방향으로만 이동.',
  wire_directional_b2: '화살표 반대편을 탭하면 흐르지 않는다.',
  wire_directional_b3: '스타터부터 화살표를 끝까지 추적하라.',

  wire_delay_title: '지연 와이어',
  wire_delay_tagline: '점선 금. 펄스가 3틱 뒤 도착.',
  wire_delay_b1: '타이밍용, 실드 강하 후 펄스 착탄.',
  wire_delay_b2: '또는 높은 임계값 노드에 2펄스 적층.',
  wire_delay_b3: '타이밍을 놓치면 첫 펄스가 먼저 감쇠한다.',

  wire_locked_title: '잠긴 와이어',
  wire_locked_tagline: '점선 회색 + 자물쇠. 무언가 열기 전까지 닫힘.',
  wire_locked_b1: '각 잠긴 와이어는 릴레이가 통제.',
  wire_locked_b2: '릴레이가 무너지면 잠긴 와이어가 열린다.',
  wire_locked_b3: '직접 급전하려고 탭 낭비하지 마라.',

  wire_forbidden_title: '금지선',
  wire_forbidden_tagline: '빨간 점선 + 십자. 닿으면 즉시 실패.',
  wire_forbidden_b1: '통과 펄스도 경보를 울린다.',
  wire_forbidden_b2: '각 스타터의 출력선을 반드시 확인.',
  wire_forbidden_b3: '경로가 빨강에 절대 닿지 않는 스타터를 골라라.',

  wire_burn_title: '소실 와이어',
  wire_burn_tagline: '황동 오렌지. 일회성 도체, 펄스 후 소진.',
  wire_burn_b1: '정확히 1펄스만 운반, 그 후 영구 소실.',
  wire_burn_b2: '한 번의 사용을 신중히 계획하라, 두 번째 기회 없음.',
  wire_burn_b3: '한번 타면 어떤 캐스케이드도 통과 못한다.',

  callout_required_crashed: '필수 노드 격파',
  callout_core_breached: '코어 돌파',
  callout_shield_dropped: '실드 강하',
  callout_relay_opened: '릴레이 개방',
  callout_protected_hit: '보호 노드 피격',

  // ── Beta: settings ─────────────────────────────────────────
  menu_settings: 'SETTINGS',
  settings_title: 'SETTINGS',
  settings_sound: 'Sound',
  settings_haptics: 'Haptics',
  settings_haptics_note: 'device only',
  settings_on: 'ON',
  settings_off: 'OFF',
  settings_replay_tutorials: 'Replay tutorials',
  settings_reset_progress: 'Reset all progress',
  settings_reset_confirm: 'TAP AGAIN TO WIPE',
  settings_done: 'DONE',

  // ── Beta: achievements / share ─────────────────────────────
  menu_achievements: 'AWARDS',
  ach_title: 'ACHIEVEMENTS',
  ach_new: 'ACHIEVEMENT UNLOCKED',
  ach_locked: 'LOCKED',
  share_button: 'SHARE',
  share_copied: 'Copied to clipboard',

  // ── Beta: daily challenge ──────────────────────────────────
  daily_title: 'DAILY',
  daily_tagline: 'One fresh puzzle every day. Keep the streak alive.',
  daily_new: 'NEW TODAY',
  daily_keep: 'KEEP IT ALIVE',
  menu_play_first: 'LEVEL 1 FIRST',
  daily_done: 'SOLVED ✓',
  daily_solved: 'DAILY SOLVED',
  daily_streak: 'STREAK',

  // ── Beta: ads / lives / hints / stats ───────────────────────
  ad_label: 'ADVERTISEMENT',
  ad_house_tagline: 'One tap. One breach. Infinite levels.',
  ad_rewarded_watching: 'Watch to earn your reward',
  ad_interstitial_watching: 'Your run continues in a moment',
  ad_rewarded_done: 'Reward unlocked',
  ad_interstitial_done: 'Thanks for playing',
  ad_reward_in: 'Reward in {n}s',
  ad_claim: 'CLAIM',
  ad_continue: 'CONTINUE',
  lives_label: 'LIVES',
  run_over_headline: 'OUT OF LIVES',
  run_over_body: 'Your run is on the line. Watch an ad for a life, or bank this run.',
  watch_for_life: 'AD  +1 LIFE',
  bank_run: 'BANK RUN',
  life_lost: '-1 LIFE',
  hint_button: 'HINT',
  hint_confirm_title: 'WATCH AD FOR A HINT?',
  hint_confirm_body: 'Rules out one breach point that does NOT solve this level. It never shows you the answer.',
  hint_yes: 'WATCH AD',
  hint_removed: 'One wrong breach point ruled out',
  hint_none_left: 'Nothing left to rule out',
  no_thanks: 'NO THANKS',
  stats_title: 'STATISTICS',
  menu_stats: 'STATS',
  stats_levels_completed: 'Levels completed',
  stats_endless_best: 'Endless best',
  stats_best_streak: 'Best streak',
  stats_fail_rate: 'Fail rate',
  stats_wins: 'Wins',
  stats_fails: 'Fails',
  stats_hints_used: 'Hints used',
  stats_ads_watched: 'Ads watched',
  stats_close: 'CLOSE',
  // ── Added with the redesign (machine draft, see TRANSLATIONS-DRAFT.md) ──
  result_map_tapped: '내 탭',
  result_map_broke: '여기서 실패',
  result_map_answer: '정답',
  result_show_answer: '정답 보기',
  menu_endless_line: '자동 생성 레벨, 목숨 3개. 깊어질수록 더 거칠어집니다.',
  menu_best: '최고 LV {n}',
  menu_best_streak: '최고 LV {n}  ·  연승 ×{s}',
  menu_resume: '이어하기 LV {n}',
  menu_start: '시작 LV 1',
  result_run_total: '이번 런 합계 {n}',
  result_streak: '연승 ×{n}',
  result_streak_wins: '{n}연속 승리',
  legend_title: '범례',
  legend_nodes: '노드',
  legend_wires: '와이어',
  legend_close: '아무 곳이나 눌러 닫기',
  settings_sync_now: '지금 동기화 ({who})',
  settings_sign_in: '로그인하여 동기화',
  settings_sign_out: '로그아웃',

};
